import React from 'react'

import iconSet from "../../icons/selection.json";
import IcomoonReact, { iconList } from "icomoon-react";

import { Card, Icon, Rating, Language } from './SkillCard'

import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

import { useEffect } from 'react';




export const SkillCard = (props) => {
    const { iconname, rating, language, ...otherProps } = props;

    var [value, setvalue] = React.useState(0);
    const percentage = value;


    const myfunction = (value) => {

        if (value < rating) {
            setvalue(value + 5);
        }

    }

    useEffect(() => {
        myfunction(value)
    })




    return (
        <Card>


            <Rating
                style={{
                    height: 50,
                    width: 50
                }}
            >
                {/* 
            <CircularProgressbar
                value={value}
                text={<tspan dy={ 10 } dx = {-20}>{percentage+"%"}</tspan>}
                styles={buildStyles({
                    // Rotation of path and trail, in number of turns (0-1)
                    rotation: 0,

                    // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                    strokeLinecap: 'butt',

                    // Text size
                    textSize: '2.5rem',

                    // How long animation takes to go from one percentage to another, in seconds
                    pathTransitionDuration: 0.8,

                    // Can specify path transition in more detail, or remove it entirely
                    // pathTransition: 'none',

                    // Colors rgb(96, 108, 136)
                    pathColor: `rgba(96, 108, 136, ${percentage / 100})`,
                    textColor: '#606c88',
                    trailColor: '#d6d6d6',
                    backgroundColor: '#3e98c7',

                })} /> */}


            </Rating>


            {iconname === "angular" ?
                <img color="#606c88" style={{ height: "5rem", width: "5rem", margin: "0 auto", marginTop: "2.5rem", }} src={require("../../icons/angular.svg")} alt="" />
                :
                iconname === "typescript" ?
                    <img color="#606c88" style={{ height: "5rem", width: "5rem", margin: "0 auto", marginTop: "2.5rem", }} src={require("../../icons/typescript.svg")} alt="" />

                    :
                    <Icon>
                        <IcomoonReact iconSet={iconSet} color="#606c88" style={{ height: "5rem", width: "5rem", margin: "0 auto" }} icon={iconname} />
                    </Icon>

            }



            <Language>
                {language}
            </Language>

        </Card>
    )
}